import { GET } from 'utils/requests.utils'

export const BASE_URL = (username) => `/shop/${username}/seller_fonts`

export const fetchList = (data) => GET(BASE_URL(data.username))
